import { render, staticRenderFns } from "./ThoughtChain.vue?vue&type=template&id=4d85ce42&scoped=true"
import script from "./ThoughtChain.vue?vue&type=script&lang=js"
export * from "./ThoughtChain.vue?vue&type=script&lang=js"
import style0 from "./ThoughtChain.vue?vue&type=style&index=0&id=4d85ce42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d85ce42",
  null
  
)

export default component.exports